<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head"></div>
          <div class="modal-con">
            <div class="modal-txt">
              <div class="form">
                <ul class="form-ul">
                  <li class="form-li">
                    <div class="form-ttl essen">
                      <!--필수값: essen-->
                      <span>비회원 조문객은 이름을 기재해주세요.</span>
                    </div>
                    <div class="form-in">
                      <label class="label">
                        <input type="text" placeholder="이름을 기재해 주세요." v-model="state.name" />
                      </label>
                    </div>
                    <div class="valid on" v-if="v$.name.$error">
                      {{ v$.name.$errors[0].$message }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray" @click="close">취소</button>
              <button class="btn" @click="fnFetch">전송</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import useVuelidate from '@vuelidate/core';
import { nonMemberValid, validationTouch } from '@/common/validation';
import { reactive } from 'vue';
import { AUTHENTICATION_STATUS, phoneState } from '@/common/utils/module/AuthenticateSupport';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack } = props.data;

const state = reactive({
  name: ''
});

const v$ = useVuelidate(nonMemberValid, state);

const fnFetch = () => {
  if (!validationTouch(v$)) return;
  if (fnCallBack) fnCallBack(state.name);

  setTimeout(() => {
    emits('close');
  }, 200);
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>
